import { Loading } from '../../components/loading';
import cn from '../../utils/cn.util';

const SuspensePage = () => {
  return (
    <div className={cn('h-screen w-full justify-center items-center flex')}>
      <Loading className="h-16 w-16" />
    </div>
  );
};

export default SuspensePage;
